module.exports = __webpack_public_path__ + "static/media/file-pdf.417affeb.svg";